export const url = {
  pro: "https://clinicdenovobackend.kwintechnologies.com/api/",
  dev: "http://47.130.2.255:3030/api/",
  local: "http://192.168.1.20:3000/api/",
};

export const API_URL = (field = "pro") => url[field];
